import { useContext, useEffect, useState } from 'react'

import { Box, Text } from '@fairfashion/design-system'

import { GlobalDataContext } from '../../contexts/globalData'
import { AddProvider } from '../../pages/Providers/components/AddProvider/add-provider.comp'
import { CompanySegment } from '../../sdk/common/company.enum'
import { ICompanyProvidersResponse } from '../../sdk/company/company.types'
import { sdk } from '../../services/sdk'

import * as Styles from './provider-form.styles'
import { ProviderFormProps } from './provider-form.types'

export const ProviderForm = ({
  open,
  setOpen,
  currentNode,
  editMode,
  onSubmit,
}: ProviderFormProps) => {
  const [loading, setLoading] = useState(false)

  const [providerData, setProviderData] = useState<
    ICompanyProvidersResponse | undefined
  >(undefined)

  const { companySegmentType, actions } = useContext(GlobalDataContext)

  const isInEditMode = async () => {
    if (
      editMode === currentNode?.code &&
      currentNode?.itemProviderRelation?.companyProviderTaxId
    ) {
      const provider = await sdk.company.getCompany(
        currentNode.itemProviderRelation.companyProviderTaxId,
      )

      if (provider) {
        setProviderData({
          id: provider.id!,
          name: provider.name,
          email: provider.email!,
          segment: provider.segment,
          taxId: provider.taxId,
          address: provider.address,
        })
      }
    }
  }

  useEffect(() => {
    isInEditMode()
  }, [])

  const handleCreateProvider = async (taxId: string) => {
    try {
      setLoading(true)
      const providers = await actions.fetchProviders()

      const provider = providers?.find((provider) => provider.taxId === taxId)

      setLoading(false)

      if (provider) {
        setProviderData(provider)

        onSubmit({
          taxId: provider.taxId,
          email: provider.email,
          name: provider.name ?? '',
          segment: provider.segment ?? CompanySegment.UNKNOWN,
        })
      }
    } catch (error) {
      console.error('Error fetching provider:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <AddProvider
        open={open}
        setOpen={setOpen}
        onSubmit={handleCreateProvider}
        loading={loading}
      />
      {providerData && (
        <Styles.Container>
          <Box direction="column">
            <Text size="small" color="grey_3">
              Nome da empresa
            </Text>
            <Text size="small" fontWeight={500}>
              {providerData.name}{' '}
            </Text>
          </Box>
          <Box direction="column">
            <Text size="small" color="grey_3">
              Identificação/CNPJ
            </Text>
            <Text size="small" fontWeight={500}>
              {providerData.taxId}
            </Text>
          </Box>
          <Box direction="column">
            <Text size="small" color="grey_3">
              Segmento
            </Text>
            <Text size="small" fontWeight={500}>
              {providerData.segment
                ? companySegmentType[providerData.segment].translate
                : 'Desconhecido'}
            </Text>
          </Box>
          <Box direction="column">
            <Text size="small" color="grey_3">
              Email
            </Text>
            <Text size="small" fontWeight={500}>
              {providerData.email}
            </Text>
          </Box>
          <Box direction="column">
            <Text size="small" color="grey_3">
              Logradouro
            </Text>
            <Text size="small" fontWeight={500}>
              {providerData.address?.street
                ? providerData.address?.street +
                  ', ' +
                  providerData.address?.number
                : '--'}
            </Text>
          </Box>
          <Box direction="column">
            <Text size="small" color="grey_3">
              Bairro
            </Text>
            <Text size="small" fontWeight={500}>
              {providerData.address ? providerData.address.district : '--'}
            </Text>
          </Box>
          <Box direction="column">
            <Text size="small" color="grey_3">
              Cidade
            </Text>
            <Text size="small" fontWeight={500}>
              {providerData.address ? providerData.address.city : '--'}
            </Text>
          </Box>
          <Box direction="column">
            <Text size="small" color="grey_3">
              Estado
            </Text>
            <Text size="small" fontWeight={500}>
              {providerData.address ? providerData.address.state : '--'}
            </Text>
          </Box>
          <Box direction="column">
            <Text size="small" color="grey_3">
              País
            </Text>
            <Text size="small" fontWeight={500}>
              {providerData.address ? providerData.address.country : '--'}
            </Text>
          </Box>
        </Styles.Container>
      )}
    </>
  )
}
